import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { Chart } from "react-google-charts";
import RichTable from '../components/richTable/RichTable.jsx'
import tableHelpers from '../helpers/TableHelpers.js'
import Dropdown from 'react-bootstrap/Dropdown';
import { getLocalDate } from '../helpers/DateHelpers.js';

function DailyBalanceChart(props) {

    const [chartStartDate, setChartStartDate] = useState(props.startDate ? getLocalDate(props.startDate) : (props.defaultToYtd ? new Date(2024, 11, 31) : new Date(2001, 1, 1)))
    const [chartEndDate, setChartEndDate] = useState(props.endDate ? getLocalDate(props.endDate) : new Date())
    const [showSPY, setShowSpy] = useState(true)
    const [syncStartValues, setSyncStartValues] = useState(true);
    const [showDrawdown, setShowDrawdown] = useState(props.defaultToDrawdown ? true : false);
    const [showDifference, setShowDifference] = useState(false);
    const [movingAverageLength, setMovingAverageLength] = useState(0);
    const [daysReturn, setDaysReturn] = useState(0);
    const [selectedChartType, setSelectedChartType] = useState("growth");
    const [allocationChartType, setAllocationChartType] = useState("exposure");

    useEffect(() => {
        (async function () {
            if (props.startDate) {
                let d = getLocalDate(props.startDate);
                if (!isNaN(d)) {
                    setChartStartDate(d);
                }
            }
            if (props.endDate) {
                let d = getLocalDate(props.endDate);
                if (!isNaN(d)) {
                    setChartEndDate(d);
                }
            }
        })();
    }, [props.startDate, props.endDate]);

    function getPriorDate(start) {
        let prior = null;
        props.chartData.forEach(e => {
            const d = new Date(e[0]);
            if (prior == null || (d < start && d > prior)) {
                prior = d;
            }
        });
        return prior;
    }

    function getYears() {
        let years = {};
        props.chartData.forEach(e => {
            years[e[0].getFullYear()] = 1;
        });

        return Object.keys(years);
    }

    function handleYearSelected(startYear, endYear) {
        console.log("startYear", startYear);
        console.log("endYear", endYear);
        let start = new Date();
        start.setMonth(0);
        start.setDate(1);
        start.setFullYear(startYear);
        let prior = getPriorDate(start);
        console.log("prior", prior);
        setChartStartDate(prior);

        let end = new Date();
        end.setMonth(11);
        end.setDate(31);
        end.setFullYear(endYear);
        setChartEndDate(end);
    }

    function handleDateSelected(startDate) {
        console.log("startDate", startDate);
        let start = new Date(startDate);
        setChartStartDate(start);
        setChartEndDate(new Date());
    }

    function getChartData() {

        let ret = props.chartData;
        if (showSPY) {
            ret = props.chartData.filter(e => {
                const d = getLocalDate(e[0]);
                const start = getLocalDate(chartStartDate);
                const end = getLocalDate(chartEndDate);
                end.setHours(23, 59, 59, 999);
                return d >= start && d <= end;
            });
            if (syncStartValues && ret.length >= 2) {
                let startValue = ret[0][1];
                let spyStartValue = ret[0][2];
                let max = null;
                let spyMax = null;
                if (spyStartValue && startValue) {
                    ret = ret.map(e => {
                        if (max === null || e[1] > max) max = e[1];
                        if (spyMax === null || e[2] > spyMax) spyMax = e[2];
                        let newSpyValue = (1 + ((e[2] - spyStartValue) / spyStartValue)) * startValue
                        const comp = tableHelpers.getEasternDateComponents(e[0]);
                        const date = comp ? `${comp.month}/${comp.day}/${comp.yearStr.slice(-2)}` : ((e[0].getUTCMonth() + 1) + "/" + e[0].getUTCDate() + "/" + (e[0].getUTCFullYear() - 2000));
                        if (showDrawdown) {
                            let drawdown = (max - e[1]) / max
                            let spyDrawdown = (spyMax - e[2]) / spyMax
                            return [date, drawdown, spyDrawdown];
                        } else if (showDifference) {
                            let perf = (e[1] - startValue) / startValue;
                            let spyPerf = (e[2] - spyStartValue) / spyStartValue;
                            return [date, perf - spyPerf];
                        } else {
                            return [date, (e[1] - startValue) / startValue, (parseInt(newSpyValue) - startValue) / startValue];
                        }
                    })
                }
            }
            if (showDrawdown) {
                ret.unshift(["Date", "Plan Drawdown", "S&P 500"]);
            } else if (showDifference) {
                ret.unshift(["Date", "Difference"]);
            } else {
                ret.unshift(["Date", "Plan Performance", "S&P 500"]);
            }
        } else {
            let max = null;
            let movingAverage = [];
            let results = [];
            for (let i = 0; i < ret.length; i++) {
                let e = ret[i];
                let d = getLocalDate(e[0]);
                const start = getLocalDate(chartStartDate);
                const end = getLocalDate(chartEndDate);
                end.setHours(23, 59, 59, 999);
                if (d < start || d > end)
                    continue;

                if (max === null || e[1] > max) max = Number(e[1]);
                const comp = tableHelpers.getEasternDateComponents(e[0]);
                const date = comp ? `${comp.month}/${comp.day}/${comp.yearStr.slice(-2)}` : ((e[0].getUTCMonth() + 1) + "/" + e[0].getUTCDate() + "/" + (e[0].getUTCFullYear() - 2000));
                if (showDrawdown) {
                    results.push([date, ((max - e[1]) / max)]);
                } else {
                    if (daysReturn > 0) {
                        let prevValue = 0;
                        if (i > daysReturn)
                            prevValue = ret[i - daysReturn][1];
                        let percentChange = prevValue === 0 ? 0 : (e[1] - prevValue) / prevValue * 100
                        console.log(date, percentChange);
                        results.push([date, percentChange]);
                    } else if (movingAverageLength > 0) {
                        let ret = e[1]
                        movingAverage.push(ret);
                        if (movingAverage.length > movingAverageLength)
                            movingAverage.shift();
                        let sum = 0;
                        movingAverage.forEach(r => sum += r);
                        results.push([date, ret, sum / movingAverage.length]);
                    } else {
                        results.push([date, e[1]]);
                    }
                }
            }
            if (showDrawdown)
                results.unshift(["Date", "Plan Drawdown"]);
            else if (showDifference)
                results.unshift(["Date", "Difference"]);
            else if (movingAverageLength > 0)
                results.unshift(["Date", "Plan Performance", { label: "Moving Average" }]);
            else
                results.unshift(["Date", "Plan Performance"]);

            return results;
        }

        return ret;
    }

    function getAllocationChartData() {
        if (props.backtestResults && props.backtestResults.dailyResults && props.backtestResults.dailyResults.length) {
            let tempChartData = [];
            let startDate = chartStartDate;
            props.backtestResults.dailyResults.filter(e => {
                const d = new Date(e.date);
                return d >= startDate && d <= chartEndDate;
            }).forEach(day => {
                let date = new Date(day.date);
                const str = (date.getUTCMonth() + 1) + "/" + date.getUTCDate() + "/" + (date.getUTCFullYear() - 2000)
                switch (allocationChartType) {
                    case "exposure":
                        tempChartData.push([str, day.long_positions / 100, 1])
                        break;
                    case "circuitBreaker":
                        tempChartData.push([str, day.short_positions / 100, 1])
                        break;
                    default:
                        tempChartData.push([str, day.long_positions / 100, 1])
                }
            });

            tempChartData.unshift(["Date", "Exposure", "100%"]);
            return tempChartData;
        } else {
            return [];
        }
    }

    function renderYearLink(year) {
        return (<div key={year}><Link id="b" className="menu-item" onClick={e => { handleYearSelected(year, year) }}>{year}</Link>&nbsp;&nbsp;</div>);
    }

    function getChartStats(chartData) {

        let stats = { profit: 0.0, spyProfit: 0.0, maxDrawdown: 0.0, maxSpyDrawdown: 0.0, avgDrawdown: 0.0, drawdownDays: 0, drawdownPct: 0.0, totalDays: 0, spyDrawdownDays: 0, spyAvgDrawdown: 0.0, spyDrawdownPct: 0.0 };

        if (chartData.length >= 3) {

            let startValue = chartData[1][1];
            let endValue = chartData[chartData.length - 1][1];

            stats.profit = (endValue - startValue) / startValue * 100;
            if (syncStartValues)
                stats.profit = endValue;


            let max = 0;
            chartData.forEach(day => {
                ++stats.totalDays;
                if (day[1] > max) {
                    max = day[1];
                }
                let drawdown = (max - day[1]) / max * 100;
                if (drawdown > stats.maxDrawdown) stats.maxDrawdown = drawdown;

                if (drawdown > 0) {
                    stats.drawdownDays += 1;
                    stats.avgDrawdown = ((((stats.drawdownDays - 1) * stats.avgDrawdown) + drawdown) / stats.drawdownDays);
                }
            })

            stats.drawdownPct = stats.drawdownDays / stats.totalDays * 100;

            if (chartData[1].length >= 3) {
                startValue = chartData[1][2];
                endValue = chartData[chartData.length - 1][2];
                stats.spyProfit = (endValue - startValue) / startValue * 100;
                if (syncStartValues)
                    stats.spyProfit = endValue;

                max = 0;
                chartData.forEach(day => {
                    if (day[2] > max) max = day[2];
                    else {
                        let drawdown = (max - day[2]) / max * 100;
                        if (drawdown > stats.maxSpyDrawdown) stats.maxSpyDrawdown = drawdown;

                        if (drawdown > 0) {
                            stats.spyDrawdownDays += 1;
                            stats.spyAvgDrawdown = ((((stats.spyDrawdownDays - 1) * stats.spyAvgDrawdown) + drawdown) / stats.spyDrawdownDays);
                        }
                    }
                })
                stats.spyDrawdownPct = stats.spyDrawdownDays / stats.totalDays * 100;
            }
        }

        return [stats];
    }

    function setChartType(type) {
        setSelectedChartType(type);
        switch (type) {
            case "growth":
                setShowDrawdown(false);
                setSyncStartValues(true);
                setShowSpy(true);
                setShowDifference(false);
                setMovingAverageLength(0);
                setDaysReturn(0);
                break;
            case "drawdown":
                setShowDrawdown(true);
                setSyncStartValues(true);
                setShowSpy(true);
                setShowDifference(false);
                setMovingAverageLength(0);
                setDaysReturn(0);
                break;
            case "difference":
                setShowDrawdown(false);
                setSyncStartValues(true);
                setShowSpy(true);
                setShowDifference(true);
                setMovingAverageLength(0);
                setDaysReturn(0);
                break;
            case "return":
                setShowDrawdown(false);
                setSyncStartValues(true);
                setShowSpy(false);
                setShowDifference(false);
                setMovingAverageLength(0);
                setDaysReturn(66);
                break;
            case "movingAverage":
                setShowDrawdown(false);
                setSyncStartValues(true);
                setShowSpy(false);
                setShowDifference(false);
                setMovingAverageLength(66);
                setDaysReturn(0);
                break;
            default:
                // Handle unknown chart type
                break;
        }
    }

    function getAllocationChartType(type) {
        switch (type) {
            case "exposure":
                return "Exposure vs. S&P 500";
            case "circuitBreaker":
                return "Circuit Breaker Scale";
            default:
                return "Exposure vs. S&P 500";
        }

    }
    function getChartType(type) {
        switch (type) {
            case "growth":
                return "Growth vs. S&P 500";
            case "drawdown":
                return "Drawdown";
            case "difference":
                return "Performance Difference vs. S&P 500";
            case "return":
                return "Rolling Return";
            case "movingAverage":
                return "Growth with Moving Average";
            default:
                return "Unknown";
        }
    }

    var mainChartOptions = {
        chartArea: { 'width': '80%', 'height': '75%' },
        legend: { position: "top" },
    }
    if ((syncStartValues && showSPY) || showDrawdown || showDifference) {
        mainChartOptions.vAxis = {
            format: 'percent'
        }
    }

    let chartData = getChartData();
    let chartStats = getChartStats(chartData);

    return (
        <div>
            {
                props.chartData.length ?
                    <div>
                        {props.hideOptions === true ? null :
                            <center>
                                {props.startDate ?
                                    <><Link id="a" className="menu-item" onClick={e => { handleDateSelected(props.startDate) }}>Since Start Date</Link>&nbsp;&nbsp;<br></br></>
                                    :
                                    null
                                }
                                <div className='sameline'>
                                    &nbsp;&nbsp;<Link id="a" className="menu-item" onClick={e => { handleYearSelected(2001, 2026) }}>All</Link>&nbsp;&nbsp;
                                    {getYears().map(year => { return renderYearLink(year) })}
                                </div>
                                <br></br>
                                <div className='sameline' style={{ margin: '10px' }}>
                                    <Dropdown width="250" onSelect={(e) => setChartType(e)}>
                                        <Dropdown.Toggle key={'chartType'} variant="secondary" id="dropdown-basic">
                                            {getChartType(selectedChartType)}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu  >
                                            <Dropdown.Item as='growth' key={'growth'} eventKey={'growth'} value={'growth'}>{getChartType('growth')}</Dropdown.Item>
                                            <Dropdown.Item as='drawdown' key={'drawdown'} eventKey={'drawdown'} value={'drawdown'}>{getChartType('drawdown')}</Dropdown.Item>
                                            <Dropdown.Item as='difference' key={'difference'} eventKey={'difference'} value={'difference'}>{getChartType('difference')}</Dropdown.Item>
                                            <Dropdown.Item as='return' key={'return'} eventKey={'return'} value={'return'}>{getChartType('return')}</Dropdown.Item>
                                            <Dropdown.Item as='movingAverage' key={'movingAverage'} eventKey={'movingAverage'} value={'movingAverage'}>{getChartType('movingAverage')}</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    {selectedChartType === "movingAverage" ?
                                        <Dropdown width="150" onSelect={(e) => setMovingAverageLength(Number(e))}>
                                            <Dropdown.Toggle key={'movingAverage'} variant="secondary" id="dropdown-basic">
                                                {movingAverageLength + " Day"}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu  >
                                                <Dropdown.Item as='days' key={'22'} eventKey={'22'} value={'22'}>22 Day</Dropdown.Item>
                                                <Dropdown.Item as='days' key={'66'} eventKey={'66'} value={'66'}>66 Day</Dropdown.Item>
                                                <Dropdown.Item as='days' key={'100'} eventKey={'100'} value={'100'}>100 Day</Dropdown.Item>
                                                <Dropdown.Item as='days' key={'125'} eventKey={'125'} value={'125'}>125 Day</Dropdown.Item>
                                                <Dropdown.Item as='days' key={'250'} eventKey={'250'} value={'250'}>250 Day</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        : null
                                    }
                                    {selectedChartType === "return" ?
                                        <Dropdown width="150" onSelect={(e) => setDaysReturn(Number(e))}>
                                            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                                {daysReturn + " Day"}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu  >
                                                <Dropdown.Item as='day' key={'22b'} eventKey={'22'} value={'22'}>22 Day</Dropdown.Item>
                                                <Dropdown.Item as='day' key={'66b'} eventKey={'66'} value={'66'}>66 Day</Dropdown.Item>
                                                <Dropdown.Item as='day' key={'100b'} eventKey={'100'} value={'100'}>100 Day</Dropdown.Item>
                                                <Dropdown.Item as='day' key={'125b'} eventKey={'125'} value={'125'}>125 Day</Dropdown.Item>
                                                <Dropdown.Item as='day' key={'250b'} eventKey={'250'} value={'250'}>250 Day</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        : null
                                    }
                                </div>
                            </center>
                        }

                        <Chart
                            chartType="AreaChart"
                            data={chartData}
                            width={props.width ? props.width : "100%"}
                            height={props.height ? props.height : "400px"}
                            options={mainChartOptions}
                            chartPackages={["corechart", "controls"]}
                        />

                        {!props.hideAllocationChart ?
                            <>
                                <center>
                                    <Dropdown width="250" onSelect={(e) => setAllocationChartType(e)}>
                                        <Dropdown.Toggle key={'allocationChartType'} variant="secondary" id="dropdown-basic">
                                            {getAllocationChartType(allocationChartType)}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item as='exposure' key={'exposure'} eventKey={'exposure'} value={'exposure'}>{getAllocationChartType('exposure')}</Dropdown.Item>
                                            <Dropdown.Item as='circuitBreaker' key={'circuitBreaker'} eventKey={'circuitBreaker'} value={'circuitBreaker'}>{getAllocationChartType('circuitBreaker')}</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </center>
                                <Chart
                                    chartType="ComboChart"
                                    data={getAllocationChartData()}
                                    width={props.width ? props.width : "100%"}
                                    height={"100px"}
                                    options={{
                                        chartArea: { 'width': '80%', 'height': '65%' },
                                        legend: { position: "none" },
                                        title: 'Daily Exposure',
                                        seriesType: "area",
                                        series: { 1: { type: "line", color: 'black' } },
                                        vAxis: {
                                            viewWindowMode: 'explicit',
                                            viewWindow: {
                                                max: allocationChartType === "circuitBreaker" ? undefined : 3,
                                                min: allocationChartType === "circuitBreaker" ? 0 : -1
                                            },
                                            format: 'percent'
                                        }
                                    }}
                                    chartPackages={["corechart", "controls"]}
                                />
                            </>
                            : null
                        }

                        {!props.hideChartSummary ?
                            <center>
                                <RichTable data={chartStats} className="table-striped table-hover table-condensed" mappers={[
                                    { title: 'Profit', field: 'profit', formatter: tableHelpers.percentFormatter },
                                    { title: 'SPY Profit', field: 'spyProfit', formatter: tableHelpers.percentFormatter, hidden: !showSPY },
                                ]} />
                            </center >
                            :
                            null
                        }

                    </div>
                    :
                    null
            }
        </div >);
}

export default DailyBalanceChart;